import React from "react";
import PropTypes from "prop-types";
import { itemShapeType } from "data/GxepStore";
import loadObjectOf from "data/util/loadObjectOf";
import Form from "lib/common/descriptorcontrols/Form/form";

export const title = "ARMUS XML Export Password Manager";

export class GenericXmlExportPasswordAdmin extends React.Component {

    constructor(props) {
        super(props);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleCancel(e) {
        e.preventDefault();
        this.props.onCancel();
    }

    handleChange(desc, value) {
        this.props.onChange(desc.key, value || ""); // no nulls!
    }

    handleSave(e) {
        e.preventDefault();
        this.props.onSave();
    }

    render() {
        const {
            passwordsLO,
        } = this.props;
        if (passwordsLO.isLoading()) return null;
        if (!passwordsLO.hasValue()) {
            if (passwordsLO.hasError()) {
                return <h2>A loading error occurred.</h2>;
            }
            return null;
        }
        const passwords = passwordsLO.getValueEnforcing();
        return <React.Fragment>
            <Form
                descriptor={{
                    key: "",
                    id: "",
                    path: "",
                    label: "",
                    type: "Form",
                    control: "form",
                    disableBehaviour: "disable",
                    childItems: passwords,
                }}
                propsResolver={it => ({
                    descriptor: {
                        config: {},
                        key: it.key,
                        id: it.key,
                        path: it.key,
                        label: it.name,
                        disableBehaviour: "disable",
                        control: "text",
                        type: "StringField",
                    },
                    onCommitChange: this.handleChange,
                    value: it.password,
                    enabled: true,
                })}
            />
            <div className="modal-footer">
                <button
                    className="btn btn-save"
                    onClick={this.handleSave}
                ><span/> Save</button>
                <button
                    onClick={this.handleCancel}
                    className="btn btn-cancel"
                ><span/> Cancel</button>
            </div>
        </React.Fragment>;
    }
}

GenericXmlExportPasswordAdmin.propTypes = {
    passwordsLO: loadObjectOf(
        PropTypes.arrayOf(itemShapeType)
    ),
    onCancel: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/genericXmlExportPassword/GenericXmlExportPasswordAdmin.js